import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                {t('categories.title')}
              </h2>
              <p className="text-foreground-500 text-sm max-w-2xl">
                {t('categories.subtitle')}
              </p>
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
            >
              <span>Zobacz wszystkie kategorie</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 hover:bg-background-200 rounded-xl p-4 md:p-5 flex flex-col items-center text-center gap-3 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-background-50 group-hover:bg-primary-50 flex items-center justify-center transition-colors">
                <i className={`${cat.icon} text-foreground-600 group-hover:text-primary-500 text-lg w-5 h-5 flex items-center justify-center transition-colors`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{cat.namePl}</h3>
                <p className="text-xs text-foreground-400">{t('categories.viewCategory')}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}